var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrticket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 32,
    fill: "#1877F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5744 47.078C69.3036 47.3412 68.9362 47.4914 68.5494 47.4914C67.118 47.4914 65.9574 48.619 65.9574 49.9906C65.9574 51.3716 67.1044 52.4934 68.5222 52.5086C69.321 52.516 70 53.0572 70 53.8332V58.653C70 62.7098 66.615 66 62.4372 66H56.1316C55.4796 66 54.9516 65.487 54.9516 64.8538V60.795C54.9516 60.0058 54.3134 59.3858 53.501 59.3858C52.708 59.3858 52.0502 60.0058 52.0502 60.795V64.8538C52.0502 65.487 51.5222 66 50.8724 66H37.5629C33.4043 66 30 62.7116 30 58.653V53.8332C30 53.0572 30.6789 52.516 31.4778 52.5086C32.8975 52.4934 34.0426 51.3716 34.0426 49.9906C34.0426 48.6564 32.9207 47.6418 31.4507 47.6418C31.0638 47.6418 30.6963 47.4914 30.4255 47.2284C30.1547 46.9654 30 46.6084 30 46.2326V41.3658C30 37.3146 33.412 34 37.5822 34H50.8724C51.5222 34 52.0502 34.513 52.0502 35.1462V39.9565C52.0502 40.727 52.708 41.3658 53.501 41.3658C54.3134 41.3658 54.9516 40.727 54.9516 39.9565V35.1462C54.9516 34.513 55.4796 34 56.1316 34H62.4372C66.615 34 70 37.2883 70 41.347V46.0822C70 46.458 69.8452 46.815 69.5744 47.078ZM53.501 55.7404C54.3134 55.7404 54.9516 55.1016 54.9516 54.3312V46.815C54.9516 46.0446 54.3134 45.4058 53.501 45.4058C52.708 45.4058 52.0502 46.0446 52.0502 46.815V54.3312C52.0502 55.1016 52.708 55.7404 53.501 55.7404Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrticket);
export default __webpack_public_path__ + "static/media/qrticket.3e71055d08eb55b082f41c056431ecde.svg";
export { ForwardRef as ReactComponent };